import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { ActionComponentDef } from '@df/ui/api/action.component.def';
import { NotificationInitiatorService } from '../notification/notification-initiator.service';
@Component({
    selector: 'action-inline',
    templateUrl: 'action-inline.html',
    styleUrls: ['action-inline.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class ActionInlineComponent extends ActionComponentDef {
    /**
     * Used as error title
     */
    @Input()
    notification?: string;
    /**
     * Notifiactions service
     */

    private notificationInitiatorService = inject(NotificationInitiatorService);
    /**
     * Extension to support notifications
     */
    protected override onUpdate() {
        if (this.notification && this.isResultVisible && this._status?.error) {
            this.notificationInitiatorService.push({
                title: this.notification,
                message: this._status.error
            });
        }
        super.onUpdate();
    }
}
